import axios from "axios";

 
const registerUser = (payload, cb) => {
  return async (dispatch, store) => {
    if (store().common.loading) {
      return;
    }
    dispatch({
      type: "TOGGLE_LOADING",
    });
 
    const response = await axios
      .post(`${process.env.REACT_APP_API_ENDPOINT}/api/v1/sign-up`, payload)
      .catch((e) => {
        dispatch({
          type: "TOGGLE_LOADING",
        });
      });
    if (response && response.data) {
      dispatch({
        type: "TOGGLE_LOADING",
      });
      if (!response.data.success) {
        dispatch({
          type: "SET_USER_MESSAGE",
          payload: {
            message: response.data.message,
            type: "ERROR",
          },
        });
      } else {
        dispatch({
          type: "SET_USER_MESSAGE",
          payload: {
            message: response.data.message,
            type: "INFO",
          },
        });
        cb();
      }
    }
  };
};

const loginUser = (payload, cb) => {
  return async (dispatch, store) => {
    if (store().common.loading) {
      return;
    }
    dispatch({
      type: "TOGGLE_LOADING",
    });
    const response = await axios
      .post(`${process.env.REACT_APP_API_ENDPOINT}/api/v1/sign-in`, payload)
      .catch((e) => {
        dispatch({
          type: "TOGGLE_LOADING",
        });
      });
    if (response && response.data) {
      dispatch({
        type: "TOGGLE_LOADING",
      });
      if (!response.data.success) {
        dispatch({
          type: "SET_USER_MESSAGE",
          payload: {
            message: response.data.message,
            type: "ERROR",
          },
        });
      } else {
        if (!response.data.data.isVerified) {
          cb("unverified_user");
        } else {
          dispatch({
            type: "SET_AUTH_DATA",
            payload: response.data.data,
          });
        }
      }
    }
  };
};

const forgotPassword = (payload, cb) => {
  return async (dispatch, store) => {
    if (store().common.loading) {
      return;
    }
    dispatch({
      type: "TOGGLE_LOADING",
    });
    const response = await axios
      .post(
        `${process.env.REACT_APP_API_ENDPOINT}/api/v1/forgot-password`,
        payload
      )
      .catch((e) => {
        dispatch({
          type: "TOGGLE_LOADING",
        });
      });
    if (response && response.data) {
      dispatch({
        type: "TOGGLE_LOADING",
      });
      if (!response.data.success) {
        dispatch({
          type: "SET_USER_MESSAGE",
          payload: {
            message: response.data.message,
            type: "ERROR",
          },
        });
      } else {
        dispatch({
          type: "SET_USER_MESSAGE",
          payload: {
            message: response.data.message,
            type: "INFO",
          },
        });
        cb();
      }
    }
  };
};

const resendVerificationEmail = (payload, cb) => {
  return async (dispatch, store) => {
    if (store().common.loading) {
      return;
    }
    dispatch({
      type: "TOGGLE_LOADING",
    });
    const response = await axios
      .post(
        `${process.env.REACT_APP_API_ENDPOINT}/api/v1/resend-verification-email`,
        payload
      )
      .catch((e) => {
        dispatch({
          type: "TOGGLE_LOADING",
        });
      });
    if (response && response.data) {
      dispatch({
        type: "TOGGLE_LOADING",
      });
      if (!response.data.success) {
        dispatch({
          type: "SET_USER_MESSAGE",
          payload: {
            message: response.data.message,
            type: "ERROR",
          },
        });
      } else {
        dispatch({
          type: "SET_USER_MESSAGE",
          payload: {
            message: response.data.message,
            type: "INFO",
          },
        });
        cb();
      }
    }
  };
};

const resetPassword = (payload, cb) => {
  return async (dispatch, store) => {
    if (store().common.loading) {
      return;
    }
    dispatch({
      type: "TOGGLE_LOADING",
    });
    const response = await axios
      .post(
        `${process.env.REACT_APP_API_ENDPOINT}/api/v1/reset-password`,
        payload
      )
      .catch((e) => {
        dispatch({
          type: "TOGGLE_LOADING",
        });
      });
    if (response && response.data) {
      dispatch({
        type: "TOGGLE_LOADING",
      });
      if (!response.data.success) {
        dispatch({
          type: "SET_USER_MESSAGE",
          payload: {
            message: response.data.message,
            type: "ERROR",
          },
        });
      } else {
        dispatch({
          type: "SET_USER_MESSAGE",
          payload: {
            message: response.data.message,
            type: "INFO",
          },
        });
        cb();
      }
    }
  };
};

const verifyEmail = (payload, cb) => {
  return async (dispatch, store) => {
    if (store().common.loading) {
      return;
    }
    dispatch({
      type: "TOGGLE_LOADING",
    });
    const response = await axios
      .post(
        `${process.env.REACT_APP_API_ENDPOINT}/api/v1/verify-email`,
        payload
      )
      .catch((e) => {
        dispatch({
          type: "TOGGLE_LOADING",
        });
      });
    if (response && response.data) {
      dispatch({
        type: "TOGGLE_LOADING",
      });
      if (!response.data.success) {
        dispatch({
          type: "SET_USER_MESSAGE",
          payload: {
            message: response.data.message,
            type: "ERROR",
          },
        });
      } else {
        dispatch({
          type: "SET_USER_MESSAGE",
          payload: {
            message: response.data.message,
            type: "INFO",
          },
        });
        cb();
      }
    }
  };
};

const logoutUser = () => {
  return {
    type: "LOGOUT_USER",
  };
};

export default {
  registerUser,
  loginUser,
  forgotPassword,
  resendVerificationEmail,
  resetPassword,
  verifyEmail,
  logoutUser,
};
